
(function () {
  var root = document.getElementById('kt-pay');
  if (!root) return;

  // ----- CONFIGURACION -----
  // Backend PROPIO de TopTickets (independiente del de KingTicket, cada uno
  // con su propia tienda de Shopify — los pedidos no se mezclan).
  var BACKEND_URL = 'https://toptickets-backend.vercel.app';
  // --------------------------

  // ----- Clip (Checkout Transparente) -----
  var selectedMethod = 'clip'; // 'clip' (tarjeta, instantaneo) o 'spei' (manual)
  var clipSDKInstance = null;
  var clipCardElement = null;
  var clipReady = false;

  var params = new URLSearchParams(window.location.search);
  var evento = params.get('evento') || '';
  var venue = params.get('venue') || '';
  var fecha = params.get('fecha') || '';
  var imagenEvento = params.get('imagen') || '';
  var itemsRaw = params.get('items');
  var items = [];
  try { items = itemsRaw ? JSON.parse(itemsRaw) : []; } catch (e) { items = []; }

  // Modo "revisar mi pedido": el cliente ya subio su comprobante antes y
  // vuelve con el enlace que le dimos, para consultar si Eduardo ya
  // confirmo el pago a mano en Shopify y, si ya lo hizo, descargar boletos.
  var orderIdParam = params.get('orderId') || '';
  var orderNameParam = params.get('orderName') || '';
  var fnParam = params.get('fn') || '';
  var lnParam = params.get('ln') || '';
  var emParam = params.get('em') || '';

  var linesEl = document.getElementById('kt-pay-lines');
  var totalEl = document.getElementById('kt-pay-total');
  var eventoEl = document.getElementById('kt-pay-evento');
  var emptyEl = document.getElementById('kt-pay-empty');
  var formEl = document.getElementById('kt-pay-form');

  if (!items || items.length === 0) {
    document.querySelector('.kt-pay__content').style.display = 'none';
    emptyEl.style.display = '';
    return;
  }

  if (evento) eventoEl.textContent = evento;

  var total = 0;
  items.forEach(function (it) {
    var subtotal = it.price * it.qty;
    total += subtotal;
    var line = document.createElement('div');
    line.className = 'kt-pay__line';
    line.innerHTML =
      '<span>' + it.name + ' x' + it.qty + '</span>' +
      '<strong>$' + subtotal.toFixed(2) + '</strong>';
    linesEl.appendChild(line);
  });
  totalEl.textContent = '$' + total.toFixed(2);

  if (orderIdParam) {
    // No mostramos el formulario de pago de nuevo: solo dejamos revisar el
    // estado del pedido y, cuando ya este pagado, descargar los boletos.
    formEl.style.display = 'none';
    var pendingElEarly = document.getElementById('kt-pay-spei-pending');
    var pendingTextEarly = document.getElementById('kt-pay-spei-pending-text');
    pendingTextEarly.textContent = orderNameParam
      ? ('Revisando el estado de tu pedido ' + orderNameParam + '.')
      : 'Revisando el estado de tu pedido.';
    pendingElEarly.style.display = '';
  }

  var submitBtn = document.getElementById('kt-pay-submit');

  // ----- Selector Tarjeta (Clip) / SPEI -----
  var methodClipBtn = document.getElementById('kt-pay-method-clip');
  var methodSpeiBtn = document.getElementById('kt-pay-method-spei');
  var clipPanel = document.getElementById('kt-pay-clip-panel');
  var speiPanel = document.getElementById('kt-pay-spei-panel');
  var clipTotalEl = document.getElementById('kt-pay-clip-total');

  function updateSubmitLabel() {
    if (!submitBtn || submitBtn.disabled) return;
    if (selectedMethod === 'clip') {
      submitBtn.textContent = 'Pagar $' + total.toFixed(2) + ' MXN con tarjeta';
    } else {
      submitBtn.textContent = 'Generar transferencia SPEI';
    }
  }

  function setMethod(method) {
    selectedMethod = method;
    if (methodClipBtn) methodClipBtn.classList.toggle('kt-pay__method-btn--active', method === 'clip');
    if (methodSpeiBtn) methodSpeiBtn.classList.toggle('kt-pay__method-btn--active', method === 'spei');
    if (clipPanel) clipPanel.style.display = method === 'clip' ? '' : 'none';
    if (speiPanel) speiPanel.style.display = method === 'spei' ? '' : 'none';
    updateSubmitLabel();
  }

  if (methodClipBtn) methodClipBtn.addEventListener('click', function () { setMethod('clip'); });
  if (methodSpeiBtn) methodSpeiBtn.addEventListener('click', function () { setMethod('spei'); });

  // Carga la llave publica de Clip desde nuestro backend (nunca va escrita en
  // el tema) y monta el campo de tarjeta del SDK de Clip.
  function initClip(apiKey) {
    if (clipReady || typeof ClipSDK === 'undefined') return;
    try {
      clipSDKInstance = new ClipSDK(apiKey);
      clipCardElement = clipSDKInstance.element.create('Card', { theme: 'light', locale: 'es' });
      clipCardElement.mount('checkout');
      clipReady = true;
    } catch (e) {
      var clipErrorsEl = document.getElementById('kt-pay-clip-errors');
      if (clipErrorsEl) clipErrorsEl.textContent = 'No se pudo cargar el formulario de tarjeta. Intenta recargar la página.';
    }
  }

  fetch(BACKEND_URL + '/api/clip-public-key')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data.apiKey) initClip(data.apiKey);
    })
    .catch(function () { /* si falla, el cliente puede usar SPEI */ });

  function readFormData() {
    var firstName = document.getElementById('kt-pay-firstname').value.trim();
    var lastName = document.getElementById('kt-pay-lastname').value.trim();
    var email = document.getElementById('kt-pay-email').value.trim();
    var address1 = document.getElementById('kt-pay-address1').value.trim();
    var city = document.getElementById('kt-pay-city').value.trim();
    var zip = document.getElementById('kt-pay-zip').value.trim();
    var state = document.getElementById('kt-pay-state').value;

    return {
      firstName: firstName,
      lastName: lastName,
      email: email,
      billingAddress: { line1: address1, city: city, state: state, postal_code: zip, country: 'MX' }
    };
  }

  var lastOrder = orderIdParam ? { id: orderIdParam, name: orderNameParam } : null;

  // Deja lista la tarjeta "Comprobante recibido": muestra un enlace que el
  // cliente puede guardar para volver despues (cuando Eduardo ya haya
  // confirmado el pago a mano en Shopify) y descargar sus boletos, y
  // conecta el boton de "verificar" con el backend.
  function wireOrderCheck(orderId) {
    var checkBtn = document.getElementById('kt-pay-spei-check');
    var statusEl = document.getElementById('kt-pay-spei-check-status');
    var dlBtn = document.getElementById('kt-pay-spei-download');
    if (!checkBtn || !orderId || checkBtn.dataset.wired) return;
    checkBtn.dataset.wired = '1';
    checkBtn.style.display = '';

    checkBtn.addEventListener('click', function () {
      checkBtn.disabled = true;
      checkBtn.textContent = 'Consultando...';
      fetch(BACKEND_URL + '/api/order-status?orderId=' + encodeURIComponent(orderId))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          checkBtn.disabled = false;
          checkBtn.textContent = 'Consultar de nuevo';
          if (data && data.paid) {
            statusEl.textContent = 'Tu pago ya está confirmado. Ya puedes descargar tus boletos.';
            if (dlBtn) dlBtn.style.display = '';
          } else {
            statusEl.textContent = 'Todavía no confirmamos tu pago. Vuelve a intentarlo más tarde.';
          }
        })
        .catch(function () {
          checkBtn.disabled = false;
          checkBtn.textContent = 'Consultar de nuevo';
          statusEl.textContent = 'No pudimos consultar tu pedido, intenta de nuevo.';
        });
    });

    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        if (downloadTicketsBtn) downloadTicketsBtn.click();
      });
    }
  }

  function fireSpeiPending(order) {
    lastOrder = order || null;
    formEl.style.display = 'none';
    var pendingEl = document.getElementById('kt-pay-spei-pending');
    var pendingText = document.getElementById('kt-pay-spei-pending-text');
    if (order && order.name) {
      pendingText.textContent = 'Tu pedido ' + order.name + ' quedó registrado como pendiente de pago.';
    }
    pendingEl.style.display = '';

    if (order && order.id) {
      var linkBox = document.getElementById('kt-pay-spei-link-box');
      var linkInput = document.getElementById('kt-pay-spei-link');
      if (linkBox && linkInput) {
        try {
          var fd = readFormData();
          var url = new URL(window.location.href);
          url.searchParams.set('orderId', order.id);
          if (order.name) url.searchParams.set('orderName', order.name);
          if (fd.firstName) url.searchParams.set('fn', fd.firstName);
          if (fd.lastName) url.searchParams.set('ln', fd.lastName);
          if (fd.email) url.searchParams.set('em', fd.email);
          linkInput.value = url.toString();
          linkBox.style.display = '';
        } catch (e) { /* si falla construir el enlace, seguimos sin el */ }
      }
      wireOrderCheck(order.id);
    }

    if (typeof fbq === 'function') {
      fbq('track', 'Purchase', {
        value: total,
        currency: 'MXN',
        content_name: evento,
        contents: items.map(function (it) { return { id: it.variantId, quantity: it.qty, item_price: it.price }; }),
        content_type: 'product'
      });
    }
  }

  // El pago con Clip se confirma al instante (a diferencia de SPEI, que
  // queda pendiente hasta que Eduardo revisa el comprobante a mano), asi
  // que aqui mostramos de una vez la tarjeta de boletos listos para
  // descargar, sin el paso de "verificar".
  function fireClipPaid(order) {
    lastOrder = order || null;
    formEl.style.display = 'none';
    var pendingEl = document.getElementById('kt-pay-spei-pending');
    var pendingText = document.getElementById('kt-pay-spei-pending-text');
    var pendingIcon = pendingEl ? pendingEl.querySelector('.kt-pay__success-check') : null;
    var pendingTitle = pendingEl ? pendingEl.querySelector('.kt-pay__success-h2') : null;
    var pendingNote = pendingEl ? pendingEl.querySelector('.kt-pay__success-note') : null;
    if (pendingIcon) { pendingIcon.textContent = '✓'; pendingIcon.classList.remove('kt-pay__success-check--pending'); }
    if (pendingTitle) pendingTitle.textContent = '¡Pago confirmado!';
    if (pendingText) {
      pendingText.textContent = order && order.name
        ? ('Tu pedido ' + order.name + ' fue pagado con tarjeta.')
        : 'Tu pedido fue pagado con tarjeta.';
    }
    if (pendingNote) pendingNote.textContent = 'Ya puedes descargar tus boletos.';
    if (pendingEl) pendingEl.style.display = '';

    var dlBtn = document.getElementById('kt-pay-spei-download');
    if (dlBtn) {
      dlBtn.style.display = '';
      if (!dlBtn.dataset.wired) {
        dlBtn.dataset.wired = '1';
        dlBtn.addEventListener('click', function () {
          if (downloadTicketsBtn) downloadTicketsBtn.click();
        });
      }
    }

    if (typeof fbq === 'function') {
      fbq('track', 'Purchase', {
        value: total,
        currency: 'MXN',
        content_name: evento,
        contents: items.map(function (it) { return { id: it.variantId, quantity: it.qty, item_price: it.price }; }),
        content_type: 'product'
      });
    }
  }

  function handleClipSubmit(formData, backendItems) {
    var clipErrorsEl = document.getElementById('kt-pay-clip-errors');
    if (clipErrorsEl) clipErrorsEl.textContent = '';

    if (!clipReady || !clipCardElement) {
      if (clipErrorsEl) clipErrorsEl.textContent = 'El formulario de tarjeta todavía no está listo, espera un momento e intenta de nuevo.';
      submitBtn.disabled = false;
      updateSubmitLabel();
      return;
    }

    clipCardElement.cardToken()
      .then(function (cardToken) {
        if (!cardToken || !cardToken.id) throw new Error('No se pudo leer tu tarjeta, revisa los datos.');
        return fetch(BACKEND_URL + '/api/create-clip-payment', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: backendItems,
            clipToken: cardToken.id,
            customer: {
              email: formData.email,
              firstName: formData.firstName,
              lastName: formData.lastName,
              phone: document.getElementById('kt-pay-phone') ? document.getElementById('kt-pay-phone').value.trim() : ''
            },
            billingAddress: formData.billingAddress
          })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.error || 'No se pudo procesar tu pago'); });
        return r.json();
      })
      .then(function (data) {
        fireClipPaid(data.shopifyOrder);
      })
      .catch(function (err) {
        if (clipErrorsEl) clipErrorsEl.textContent = err.message || 'No se pudo procesar tu pago, intenta de nuevo.';
        submitBtn.disabled = false;
        updateSubmitLabel();
      });
  }

  // Reduce el tamaño de la imagen del comprobante antes de mandarla (fotos de
  // celular pueden pesar varios MB; el backend acepta como máximo ~4MB).
  function compressReceiptImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file.type || file.type.indexOf('image/') !== 0) {
        // No es imagen (ej. PDF): lo mandamos tal cual en base64, sin comprimir.
        var readerRaw = new FileReader();
        readerRaw.onload = function () { resolve(readerRaw.result); };
        readerRaw.onerror = reject;
        readerRaw.readAsDataURL(file);
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          var maxW = 1200;
          var scale = Math.min(1, maxW / img.width);
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg', 0.7));
        };
        img.onerror = reject;
        img.src = reader.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function handleManualSpeiSubmit(formData, backendItems) {
    var fileInput = document.getElementById('kt-pay-receipt');
    var file = fileInput.files && fileInput.files[0];
    var errorsEl = document.getElementById('kt-pay-form-errors');

    if (!file) {
      errorsEl.textContent = 'Sube tu comprobante de transferencia para continuar.';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Generar transferencia SPEI';
      return;
    }

    compressReceiptImage(file)
      .then(function (receiptBase64) {
        return fetch(BACKEND_URL + '/api/create-manual-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: backendItems,
            customer: { email: formData.email, firstName: formData.firstName, lastName: formData.lastName },
            billingAddress: formData.billingAddress,
            evento: evento,
            receiptBase64: receiptBase64,
            receiptFileName: file.name,
            policyAcceptedAt: policyAcceptedAt
          })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.error || 'No se pudo registrar tu pedido'); });
        return r.json();
      })
      .then(function (data) {
        fireSpeiPending(data.shopifyOrder);
      })
      .catch(function (err) {
        errorsEl.textContent = err.message;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Generar transferencia SPEI';
      });
  }

  var receiptInput = document.getElementById('kt-pay-receipt');
  var receiptNameEl = document.getElementById('kt-pay-receipt-name');
  var speiTotalEl = document.getElementById('kt-pay-spei-total');
  if (receiptInput) {
    receiptInput.addEventListener('change', function () {
      var f = receiptInput.files && receiptInput.files[0];
      receiptNameEl.textContent = f ? ('Archivo: ' + f.name) : '';
    });
  }

  var policyCheckbox = document.getElementById('kt-pay-policy-accept');
  var policyErrorEl = document.getElementById('kt-pay-policy-error');
  var policyAcceptedAt = null;

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!policyCheckbox || !policyCheckbox.checked) {
      policyErrorEl.textContent = 'Marca la casilla de venta final para poder continuar.';
      return;
    }
    policyErrorEl.textContent = '';
    document.getElementById('kt-pay-form-errors').textContent = '';
    policyAcceptedAt = new Date().toISOString();

    var formData = readFormData();
    var backendItems = items.map(function (it) {
      return { variantId: it.variantId, quantity: it.qty };
    });

    submitBtn.disabled = true;
    if (selectedMethod === 'clip') {
      submitBtn.textContent = 'Procesando pago...';
      handleClipSubmit(formData, backendItems);
    } else {
      submitBtn.textContent = 'Subiendo comprobante...';
      handleManualSpeiSubmit(formData, backendItems);
    }
  });

  if (speiTotalEl) speiTotalEl.textContent = total.toFixed(2);
  if (clipTotalEl) clipTotalEl.textContent = total.toFixed(2);
  setMethod(selectedMethod);

  // ----- Boletos digitales con QR -----
  var downloadTicketsBtn = document.getElementById('kt-pay-download-tickets');
  var ticketsStatusEl = document.getElementById('kt-pay-tickets-status');

  if (orderIdParam) { wireOrderCheck(orderIdParam); }

  function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
    var words = (text || '').split(' ');
    var line = '';
    var lines = [];
    for (var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + ' ';
      if (ctx.measureText(testLine).width > maxWidth && n > 0) {
        lines.push(line.trim());
        line = words[n] + ' ';
      } else {
        line = testLine;
      }
    }
    lines.push(line.trim());
    lines = lines.slice(0, maxLines || 2);
    lines.forEach(function (l, i) { ctx.fillText(l, x, y + i * lineHeight); });
    return lines.length;
  }

  function roundRectPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function loadTicketImage(url) {
    return new Promise(function (resolve) {
      if (!url) { resolve(null); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      var done = false;
      img.onload = function () { if (!done) { done = true; resolve(img); } };
      img.onerror = function () { if (!done) { done = true; resolve(null); } };
      img.src = url;
      setTimeout(function () { if (!done) { done = true; resolve(null); } }, 4000);
    });
  }

  function drawCoverImage(ctx, img, x, y, w, h) {
    var ir = img.width / img.height;
    var r = w / h;
    var sx, sy, sw, sh;
    if (ir > r) {
      sh = img.height;
      sw = sh * r;
      sx = (img.width - sw) / 2;
      sy = 0;
    } else {
      sw = img.width;
      sh = sw / r;
      sx = 0;
      sy = (img.height - sh) / 2;
    }
    ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
  }

  function drawAndDownloadTicket(ticket) {
    return new Promise(function (resolve, reject) {
      var scratch = document.getElementById('kt-qr-scratch');
      scratch.innerHTML = '';
      var validateUrl = BACKEND_URL + '/api/validar?code=' + encodeURIComponent(ticket.code);

      try {
        new QRCode(scratch, {
          text: validateUrl,
          width: 300,
          height: 300,
          correctLevel: QRCode.CorrectLevel.M
        });
      } catch (e) {
        reject(e);
        return;
      }

      setTimeout(function () {
        loadTicketImage(imagenEvento).then(function (bannerImg) {
          try {
            var qrEl = scratch.querySelector('img') || scratch.querySelector('canvas');
            var W = 700, H = 1060;
            var canvas = document.createElement('canvas');
            canvas.width = W;
            canvas.height = H;
            var ctx = canvas.getContext('2d');

            var notchY = 910;
            var radius = 26;

            // --- fondo recortado con esquinas redondeadas ---
            ctx.save();
            roundRectPath(ctx, 0, 0, W, H, radius);
            ctx.clip();
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, W, H);

            // --- encabezado: logo + fecha/hora ---
            ctx.fillStyle = '#171717';
            ctx.font = 'bold 30px -apple-system, Helvetica, Arial, sans-serif';
            ctx.textAlign = 'left';
            ctx.fillText('TT', 32, 66);

            var evtDate = '', evtTime = '';
            var fechaStr = ticket.fecha || fecha || '';
            var timeMatch = fechaStr.match(/(\d{1,2}:\d{2})/);
            if (timeMatch) {
              evtTime = timeMatch[1];
              evtDate = fechaStr.replace(timeMatch[1], '').replace(/[,\-]+$/, '').trim();
            } else {
              evtDate = fechaStr;
            }

            ctx.textAlign = 'right';
            ctx.font = 'bold 12px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#9a9a9a';
            ctx.fillText('FECHA', W - 150, 38);
            ctx.fillStyle = '#171717';
            ctx.font = 'bold 22px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillText(evtDate || 'Consulta fecha', W - 150, 66);

            if (evtTime) {
              ctx.font = 'bold 12px -apple-system, Helvetica, Arial, sans-serif';
              ctx.fillStyle = '#9a9a9a';
              ctx.fillText('HORA', W - 32, 38);
              ctx.fillStyle = '#171717';
              ctx.font = 'bold 22px -apple-system, Helvetica, Arial, sans-serif';
              ctx.fillText(evtTime, W - 32, 66);
            }

            // --- imagen del evento ---
            var bannerY = 110, bannerH = 300;
            if (bannerImg) {
              drawCoverImage(ctx, bannerImg, 0, bannerY, W, bannerH);
              ctx.fillStyle = 'rgba(0,0,0,0.15)';
              ctx.fillRect(0, bannerY, W, bannerH);
            } else {
              ctx.fillStyle = '#171717';
              ctx.fillRect(0, bannerY, W, bannerH);
              ctx.fillStyle = '#ffffff';
              ctx.font = 'bold 24px -apple-system, Helvetica, Arial, sans-serif';
              ctx.textAlign = 'center';
              wrapText(ctx, ticket.evento || evento, W / 2, bannerY + bannerH / 2, W - 100, 30, 2);
            }

            // --- watermark "Kt" ---
            ctx.save();
            ctx.globalAlpha = 0.05;
            ctx.fillStyle = '#171717';
            ctx.font = 'bold 26px -apple-system, Helvetica, Arial, sans-serif';
            ctx.textAlign = 'left';
            for (var wy = bannerY + bannerH + 30; wy < H - 20; wy += 62) {
              for (var wx = -20; wx < W; wx += 96) {
                ctx.fillText('TT', wx + ((Math.round(wy / 62)) % 2 ? 45 : 0), wy);
              }
            }
            ctx.restore();

            // --- evento ---
            var contentTop = bannerY + bannerH + 42;
            ctx.textAlign = 'left';
            ctx.fillStyle = '#9a9a9a';
            ctx.font = 'bold 11px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillText('EVENTO', 32, contentTop);

            ctx.fillStyle = '#171717';
            ctx.font = 'bold 23px -apple-system, Helvetica, Arial, sans-serif';
            var titleLines = wrapText(ctx, (ticket.evento || evento).toUpperCase(), 32, contentTop + 28, W - 64, 28, 2);

            ctx.font = '15px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#555';
            ctx.fillText(ticket.venue || venue || '', 32, contentTop + 28 + titleLines * 28 + 6);

            // --- divisor ---
            var divY = contentTop + 100;
            ctx.strokeStyle = '#e6e6e2';
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(32, divY);
            ctx.lineTo(W - 32, divY);
            ctx.stroke();

            // --- fila Lugar / Zona / Boleto ---
            var rowLabelY = divY + 34;
            var rowValueY = rowLabelY + 26;
            var cols = [32, 296, 500];
            var labels = ['LUGAR', 'ZONA', 'BOLETO'];
            var values = [
              (ticket.venue || venue || '—'),
              (ticket.zona || '—'),
              (ticket.ticketIndex + ' de ' + ticket.ticketTotal)
            ];
            for (var c = 0; c < 3; c++) {
              ctx.fillStyle = '#9a9a9a';
              ctx.font = 'bold 11px -apple-system, Helvetica, Arial, sans-serif';
              ctx.fillText(labels[c], cols[c], rowLabelY);
              ctx.fillStyle = '#171717';
              ctx.font = 'bold 17px -apple-system, Helvetica, Arial, sans-serif';
              wrapText(ctx, values[c], cols[c], rowValueY, c === 0 ? 250 : 180, 20, 2);
            }

            // --- divisor ---
            var divY2 = rowValueY + 46;
            ctx.beginPath();
            ctx.moveTo(32, divY2);
            ctx.lineTo(W - 32, divY2);
            ctx.stroke();

            // --- QR + texto ---
            var qrSize = 190;
            var qrX = 32, qrY = divY2 + 30;
            ctx.fillStyle = '#ffffff';
            ctx.strokeStyle = '#e6e6e2';
            ctx.lineWidth = 1;
            roundRectPath(ctx, qrX - 8, qrY - 8, qrSize + 16, qrSize + 16, 10);
            ctx.fill();
            ctx.stroke();
            if (qrEl) ctx.drawImage(qrEl, qrX, qrY, qrSize, qrSize);

            var textX = qrX + qrSize + 30;
            var textY = qrY + 10;
            ctx.fillStyle = '#171717';
            ctx.font = 'bold 16px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillText('Este es tu boleto.', textX, textY);
            textY += 24;
            ctx.font = '13.5px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#555';
            var l1 = wrapText(ctx, 'Preséntalo en el acceso el día del evento.', textX, textY, W - textX - 32, 18, 2);
            textY += l1 * 18 + 12;
            ctx.font = 'bold 14px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#171717';
            ctx.fillText('No es necesario imprimir.', textX, textY);
            textY += 22;
            ctx.font = '13.5px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#555';
            var l2 = wrapText(ctx, 'Solo muestra el QR desde tu celular.', textX, textY, W - textX - 32, 18, 2);
            textY += l2 * 18 + 14;
            ctx.font = 'italic 12.5px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#8a8a8a';
            wrapText(ctx, 'Este QR estará activo hasta el día del evento.', textX, textY, W - textX - 32, 17, 2);

            // --- notches (efecto de boleto rasgado) ---
            ctx.globalCompositeOperation = 'destination-out';
            ctx.beginPath();
            ctx.arc(0, notchY, radius, 0, Math.PI * 2);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(W, notchY, radius, 0, Math.PI * 2);
            ctx.fill();
            ctx.globalCompositeOperation = 'source-over';

            // --- línea punteada ---
            ctx.strokeStyle = '#cfcfcf';
            ctx.lineWidth = 2;
            ctx.setLineDash([6, 6]);
            ctx.beginPath();
            ctx.moveTo(radius + 10, notchY);
            ctx.lineTo(W - radius - 10, notchY);
            ctx.stroke();
            ctx.setLineDash([]);

            // --- código de barras ---
            var barcodeY = notchY + 34;
            if (typeof JsBarcode !== 'undefined') {
              try {
                var barcodeCanvas = document.createElement('canvas');
                JsBarcode(barcodeCanvas, ticket.code, {
                  format: 'CODE128',
                  displayValue: false,
                  background: '#ffffff',
                  lineColor: '#171717',
                  width: 2.4,
                  height: 62,
                  margin: 0
                });
                var bcW = 320, bcH = 62 * (bcW / barcodeCanvas.width);
                ctx.drawImage(barcodeCanvas, (W - bcW) / 2, barcodeY, bcW, bcH);
                ctx.font = '12.5px monospace';
                ctx.fillStyle = '#555';
                ctx.textAlign = 'center';
                ctx.fillText(ticket.code, W / 2, barcodeY + bcH + 20);
              } catch (e) { /* si falla el código de barras, seguimos sin él */ }
            }

            // --- pie ---
            ctx.font = '12px -apple-system, Helvetica, Arial, sans-serif';
            ctx.fillStyle = '#9a9a9a';
            ctx.textAlign = 'center';
            ctx.fillText('¡Gracias por tu compra!   |   Disfruta el evento', W / 2, H - 26);

            ctx.restore();

            // --- borde exterior ---
            roundRectPath(ctx, 1, 1, W - 2, H - 2, radius);
            ctx.strokeStyle = '#171717';
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(0, notchY, radius, -Math.PI / 2, Math.PI / 2);
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(W, notchY, radius, Math.PI / 2, -Math.PI / 2);
            ctx.stroke();

            var dataUrl = canvas.toDataURL('image/png');
            var a = document.createElement('a');
            a.href = dataUrl;
            a.download = 'boleto-' + (ticket.shopifyOrderName || 'topticket').replace(/[^a-zA-Z0-9-]/g, '') + '-' + ticket.ticketIndex + '.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            scratch.innerHTML = '';
            resolve();
          } catch (e) {
            reject(e);
          }
        });
      }, 150);
    });
  }

  function downloadTicketsSequentially(tickets) {
    var i = 0;
    function next() {
      if (i >= tickets.length) return Promise.resolve();
      return drawAndDownloadTicket(tickets[i]).then(function () {
        i++;
        return new Promise(function (resolve) { setTimeout(resolve, 500); }).then(next);
      });
    }
    return next();
  }

  if (downloadTicketsBtn) {
    downloadTicketsBtn.addEventListener('click', function () {
      if (!lastOrder || !lastOrder.id) {
        ticketsStatusEl.textContent = 'No encontramos tu pedido, contáctanos.';
        return;
      }
      downloadTicketsBtn.disabled = true;
      downloadTicketsBtn.textContent = 'Generando...';
      ticketsStatusEl.textContent = '';

      var ticketItems = items.map(function (it) { return { name: it.name, qty: it.qty }; });

      fetch(BACKEND_URL + '/api/tickets-generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shopifyOrderId: lastOrder.id,
          shopifyOrderName: lastOrder.name,
          evento: evento,
          venue: venue,
          fecha: fecha,
          items: ticketItems,
          customer: {
            firstName: document.getElementById('kt-pay-firstname').value.trim() || fnParam,
            lastName: document.getElementById('kt-pay-lastname').value.trim() || lnParam,
            email: document.getElementById('kt-pay-email').value.trim() || emParam
          }
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.error || 'No se pudieron generar tus boletos'); });
          return r.json();
        })
        .then(function (data) {
          downloadTicketsBtn.textContent = 'Descargando...';
          return downloadTicketsSequentially(data.tickets || []);
        })
        .then(function () {
          downloadTicketsBtn.disabled = false;
          downloadTicketsBtn.textContent = 'Descargar tus entradas';
        })
        .catch(function (err) {
          ticketsStatusEl.textContent = err.message || 'No se pudieron generar tus boletos.';
          downloadTicketsBtn.disabled = false;
          downloadTicketsBtn.textContent = 'Descargar tus entradas';
        });
    });
  }
})();
